import { Color, ColorSAP } from '../ontego-ui';
import { styled } from '@mui/material';

const Styled = {};

Styled.AddNoteIconButton = styled("div")(() => ({
    width: 32,
    height: 32,
    cursor: 'pointer',
    borderRadius: '50%',
    background: "transparent",
    transition: 'all 0.3s ease',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
    "& svg": {
        width: 24,
        height: 24,
        color: Color.primary[100],
        transition: 'all 0.3s ease'
    },
}));

Styled.DeleteIconButton = styled("div")(() => ({
    width: 32,
    height: 32,
    cursor: 'pointer',
    borderRadius: '50%',
    background: "transparent",
    transition: 'all 0.15s ease',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
        width: 24,
        height: 24,
        color: ColorSAP.danger[50],
        transition: 'all 0.15s ease'
    },
}));

export default Styled;